<section class="container mobiledb-Container waitlist-container">
  <div class="row m-0 p-0">
    <div class="col-md-7">&nbsp;</div>
    <aside id="waitlist-aside2" class="col-md-5">

      <div class="row justify-content-end">
        <div class="col-md-6 dshbrd"><a (click)="gotoDashboard()"><span class="greenbottom"><img
                src="assets/icons/{{baseSiteId}}/chevron-left_2.svg" width="14">&nbsp;Back to dashboard</span></a>
        </div>
        <div class="dshbrdXLPrnt"><a (click)="downloadfile()"><span class="greenbottom"><img width="14"
                src="assets/icons/{{baseSiteId}}/excel_new.png">&nbsp;XLS</span></a>
        </div>
        <div class="col-md-3 dshbrdXLPrnt"><a (click)="printFunc()"><span class="greenbottom"><img
                src="../../../assets/icons/{{baseSiteId}}/print.svg" width="16">&nbsp;Print</span></a></div>
      </div>


    </aside>
  </div>
  <div class="row space-evenly">




    <div class="col-md-8" style="margin-right:-3px;">
      <div class="row">
        <div class="col-md-12 leftPanel m-0 p-0">

          <div class="container m-0 p-0">
            <p class="introtext" [innerHTML]="dataRes?.message"></p>
            <div *ngFor="let itm of dataRes?.seasonOrders">
              <div class="prodBlock" *ngIf="itm?.waitlistOrders.length>0">
                <span class="formulaTitle">{{itm?.code}} formula</span>
                <div class="row">
                  <div class="col-md-12 bottomline"></div>
                </div>
                <div *ngFor="let itm2 of itm?.waitlistOrders">

                  <div class="row GBrow m-0 p-0">
                    <div class="col-12 col-md-8">
                      <div class="row">
                        <div class="col-md-3 img-product">
                          <img src="{{itm2.product?.thumbNailImg}}" height="50px" class="imgThumbnail">
                        </div>
                        <div class="col-md-9 productName" (click)="productDetails(itm2?.product)"
                          [innerHTML]="itm2?.product.variantProductDescription">

                        </div>
                      </div>
                      <p class="ndcCode" *ngIf="itm2?.product?.ndcCode">
                        {{itm2?.product?.ndcCode}}</p>
                      <div class="row">
                        <div class="col product-code">{{itm2?.product?.code}} | {{itm2?.product?.manufacturer}}
                        </div>
                      </div>
                      <p class="inner-text" *ngIf="itm2?.product?.innerText && itm2?.product?.innerText !== ''">
                        <span [innerHtml]="itm2?.product?.innerText"></span>
                      </p>
                    </div>
                    <div class="col-12 col-md-4"
                      *ngIf="isGovtCustomer && isGovtLocationSelected && !itm2?.conditions;else normalUserFlow">
                      <div class="row prod-no-contract">Product not on<br /> contract</div>
                    </div>
                    <ng-template #normalUserFlow>
                      <div class="col-12 col-md-4">
                        <div class="row">
                          <div class="col-12 p-0 unitareadosesAlign">
                            <p class="dosestext p-0">Units</p>
                            <section class="unit-area mb-1" id="unitArea">
                              <span class="disabled " aria-hidden="true" class="no-print"
                                id="{{'minusIcon'+itm2?.product.code}}">
                                <img *ngIf="itm2.status!='EXPORTED' && itm2?.quantity>0"
                                  (click)="performQuantityComputation(itm2?.product.code,itm2?.quantity,'less',itm2.status)"
                                  src="assets/icons/{{baseSiteId}}/less.svg" id="{{'unitMinus'+itm2?.product.code}}"
                                  alt="">
                                <img *ngIf="itm2.status=='EXPORTED'" src="../../assets/icons/less-disable.svg"
                                  id="{{'unitMinusDisable'+itm2?.product.code}}" alt="">
                                <img *ngIf="itm2.status!='EXPORTED' && itm2?.quantity<1"
                                  src="../../assets/icons/less-disable.svg"
                                  id="{{'unitMinusDisable'+itm2?.product.code}}" alt="">
                              </span>
                              <input type="number" class="prod-quantity text-center" value={{itm2?.quantity}}
                                (keyup)="performQuantityComputation2(itm2?.product.code,itm2?.quantity,'keyup')"
                                id="{{'prodQuantity'+itm2?.product?.code}}" min="1" max="9999"
                                onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                                onkeydown="javascript: return event.keyCode == 69 ? false : true"
                                [disabled]="itm2.status=='EXPORTED'" appNoMouseScroll />
                              <span class="" aria-hidden="true" class="no-print" id="{{'plusIcon'+itm2?.product.code}}">
                                <img *ngIf="itm2.status!='EXPORTED'"
                                  (click)="performQuantityComputation(itm2?.product.code,itm2?.quantity,'add',itm2.status)"
                                  src="assets/icons/{{baseSiteId}}/more.svg" id="{{'unitPlus'+itm2?.product.code}}"
                                  alt="">
                                <img *ngIf="itm2.status=='EXPORTED'" src="../../assets/icons/more-disable.svg"
                                  id="{{'unitPlusDisable'+itm2?.product.code}}" alt="">
                              </span>
                            </section>


                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 p-0 unitareadosesAlign">
                            <p class="dosestext mb-0">{{itm2?.TotalitemQty}} doses</p>
                            <p class="waitlistLabel" *ngIf="itm2.status!='EXPORTED'">Waitlist</p>
                            <p class="waitlistLabel" *ngIf="itm2.status=='EXPORTED'">Waitlist Under Review</p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="row">
                    <div class="col-md-12 bottomline"></div>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <aside id="waitlist-aside" style="background-color: #FFF;" class="col-md-4">
      <form class="contact-form" id="#waitlistrightsection" [formGroup]="contactForm">
        <section class="d-flex flex-column" style="margin-top:30px;">
          <button tabindex="0" disabled
            *ngIf="(!POnameEdited && !ContactnameEdited && !editDeliveryHrs && !inValid) || faxNumberError" id="SaveBtn"
            class="btn-primary" (click)="saveAllData()">Save Changes</button>

          <button tabindex="0" *ngIf="(ContactnameEdited || POnameEdited || editDeliveryHrs) && !faxNumberError"
            id="SaveBtn" class="btn-primary" (click)="saveAllData()">Save Changes</button>
          <button class="btn-secondary" (click)="closeEdit()">Undo Changes</button>
        </section>
        <section class="basic-details-section">
          <div class="d-flex flex-row justify-content-between">
            <h3>Details</h3>
            <a href="javascript:void(0)" (click)="editPO()"
              style="background: url('../../../assets/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box"
              *ngIf="!editPo" class="edit-icon">Edit</a>
          </div>
          <div class="basic-details">
            <div class="basic-details__shipTo detailAddress">
              <label for="shipTo" class="shipTo">Ship To</label>
              <ul [ngStyle]="{'list-style': 'none', 'padding': '0'}">
                <li>{{dataRes?.shippingAddress?.companyName}} ({{dataRes?.shippingAddress?.accountNumber}})</li>
                <li>{{dataRes?.shippingAddress?.line1}}</li>
                <li>{{dataRes?.shippingAddress?.town}}, {{dataRes?.shippingAddress?.id}}
                  {{dataRes?.shippingAddress?.poPostalCode}}</li>
              </ul>
            </div>
            <div class="basic-details__po">
              <label for="po" class="shipTo">PO#</label>
              <span *ngIf="!editPo">{{dataRes?.poNumber}}</span>
              <input type="text" *ngIf="editPo" (keyup)="changePOname()" [(ngModel)]="dataRes.poNumber"
                formControlName="poName">
            </div>
          </div>
        </section>
        <section class="contact-section">
          <div class="d-flex flex-row justify-content-between">
            <h3>Contact</h3>
            <a (click)="editContactmethod()" *ngIf="!editContact"
              style="background: url('../../../assets/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box"
              class="edit-icon">Edit</a>
          </div>
          <p>This is who we'll contact for updates on waitlisted items</p>

          <div class="formFields row">
            <label class="formLabel col-sm-4">Name</label>
            <span *ngIf="!editContact" class="readonly formlabelValue col-sm-8">{{dataRes?.contactName}}</span>
            <div *ngIf="editContact" class="w-100 namealign"><input type="text" formControlName="name"
                [(ngModel)]="dataRes.contactName" (keyup)="changeContactname()"
                onkeydown="return /[a-z\s'-]/i.test(event.key)" *ngIf="editContact" class="formElement"></div>

          </div>
          <div class="formFields row" *ngIf="!editContact">
            <!-- use the label & span to display 'email' or 'fax' conditionaly -->
            <label class="formLabel col-sm-4" *ngIf="dataRes?.emailSelected">Email</label>
            <label class="formLabel col-sm-4" *ngIf="!dataRes?.emailSelected && dataRes?.contactFax">Fax</label>
            <label class="formLabel col-sm-4" *ngIf="!dataRes?.emailSelected && !dataRes?.contactFax">Email</label>
            <span class="readonly formlabelValue col-sm-8"
              *ngIf="dataRes?.emailSelected">{{dataRes?.contactEmail}}</span>
            <span class="readonly formlabelValue col-sm-8"
              *ngIf="!dataRes?.emailSelected && dataRes?.contactFax">{{dataRes?.contactFax}}</span>
            <span class="readonly formlabelValue col-sm-8"
              *ngIf="!dataRes?.emailSelected && !dataRes?.contactFax">{{dataRes?.contactEmail}}</span>
            </div>
          <div *ngIf="editContact">
            <h4 class="contactmethod">Prefered contact method</h4>
            <div>
              <label class="formLabel">Email</label>
              <div class="row rowBtmCls">
                <div class="col-sm-2 cotact-radio alignright">
                  <input type="radio" id="orderConfirmationYesRadio" name="orderConfirmation" value="email"
                    *ngIf="dataRes?.emailSelected" checked (click)="contactmethodValchk($event)" />
                  <input type="radio" id="orderConfirmationYesRadio" name="orderConfirmation" value="email"
                    *ngIf="!dataRes?.emailSelected" (click)="contactmethodValchk($event)" />
                </div>
                <div class="col-sm-10 cotact-input">
                  <ng-select *ngIf="!dataRes?.disableFax && !dataRes?.emailSelected && contactmethod"
                    [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                    (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                    bindValue="isocode" placeholder="Please select" formControlName="email"
                    class="dropdown-credit disabled" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="!dataRes?.disableFax && !dataRes?.emailSelected && !contactmethod"
                    [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                    [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                    formControlName="email" class="dropdown-credit" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="!dataRes?.disableFax && dataRes?.emailSelected" [searchable]="false"
                    [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                    [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                    formControlName="email" class="dropdown-credit" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="dataRes?.disableFax && dataRes?.emailSelected && !contactmethod"
                    [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                    [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                    formControlName="email" class="dropdown-credit" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="dataRes?.disableFax && !dataRes?.emailSelected && !contactmethod"
                    [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                    [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                    formControlName="email" class="dropdown-credit" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="dataRes?.disableFax && dataRes?.emailSelected && contactmethod"
                    [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                    (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                    bindValue="isocode" placeholder="Please select" formControlName="email"
                    class="dropdown-credit disabled" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                  <ng-select *ngIf="dataRes?.disableFax && !dataRes?.emailSelected && contactmethod"
                    [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                    (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                    bindValue="isocode" placeholder="Please select" formControlName="email"
                    class="dropdown-credit disabled" (click)="changeColor()">
                    <ng-option disabled>Select Email Address</ng-option>
                    <ng-option *ngFor="let itm of dataRes?.arrForEmailRightSide" [value]="itm">{{itm}}</ng-option>
                    <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                  </ng-select>
                </div>



              </div>
              <div class="row" *ngIf="newemail">
                <div class="col-sm-2 alignright">&nbsp;</div>
                <div class="col-sm-10"><input type="email" #box (keyup)="addnewemail(box.value)" class="formElement"
                    name="addnewEmail" required>
                  <div class="errorlabel" *ngIf="newEmailError">Please enter valid email address</div>
                </div>
              </div>
            </div>
            <div *ngIf="dataRes?.disableFax">
              <label class="formLabel">Fax</label>
              <div class="row rowBtmCls">
                <div class="col-sm-2 cotact-radio alignright">

                  <input type="radio" id="orderConfirmationNoRadio" name="orderConfirmation" value="fax" checked
                    *ngIf="!dataRes?.emailSelected" (click)="contactmethodValchk($event)" />

                  <input type="radio" id="orderConfirmationNoRadio" name="orderConfirmation" value="fax"
                    *ngIf="dataRes?.emailSelected" (click)="contactmethodValchk($event)" />


                </div>
                <!-- <div class="col-sm-10"><input type="text" class="formElement"
                    *ngIf="dataRes.emailSelected && !contactmethod" placeholder="XXX-XXX-XXXX"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask disabled id="faxcontactmethod" formControlName="fax">

                  <input type="text" class="formElement" *ngIf="!dataRes.emailSelected && !contactmethod"
                    placeholder="XXX-XXX-XXXX" [(ngModel)]="dataRes.contactFax" appPhoneMask disabled
                    id="faxcontactmethod" formControlName="fax">

                  <input type="text" class="formElement" *ngIf="dataRes.emailSelected && contactmethod"
                    placeholder="XXX-XXX-XXXX" [(ngModel)]="dataRes.contactFax" appPhoneMask id="faxcontactmethod"
                    formControlName="fax">
                  <input type="text" class="formElement" placeholder="XXX-XXX-XXXX"
                    *ngIf="!dataRes.emailSelected && contactmethod" id="faxcontactmethod"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask formControlName="fax">
                </div> -->

                <div class="col-sm-10 cotact-input fax-div"><input #faxnumber type="text"
                    (keyup)="validateFaxNumber(faxnumber.value)" class="formElement"
                    *ngIf="dataRes?.emailSelected && !contactmethod" placeholder="XXX-XXX-XXXX"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask disabled id="faxcontactmethod" formControlName="fax">

                  <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                    *ngIf="!dataRes?.emailSelected && !contactmethod" placeholder="XXX-XXX-XXXX"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask disabled id="faxcontactmethod" formControlName="fax">

                  <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                    *ngIf="dataRes?.emailSelected && contactmethod" placeholder="XXX-XXX-XXXX"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask id="faxcontactmethod" formControlName="fax">
                  <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                    placeholder="XXX-XXX-XXXX" *ngIf="!dataRes?.emailSelected && contactmethod" id="faxcontactmethod"
                    [(ngModel)]="dataRes.contactFax" appPhoneMask formControlName="fax">

                  <div class="errorlabel" *ngIf="faxNumberError">Please enter valid fax number</div>
                </div>
              </div>
            </div>
          </div>

          <div class="formFields row basic-details__po">
            <label class="formLabel col-sm-4">Placed by</label>
            <span *ngIf="!editContact" class="readonly formlabelValue col-sm-8">{{dataRes?.placedBy}}</span>
            <div class="w-100" *ngIf="editContact"></div>
            <input type="text" disabled *ngIf="editContact" [value]="dataRes.placedBy" [(ngModel)]="dataRes.placedBy"
              class="formElement" formControlName="placed">
          </div>

        </section>
        <section class="delivery-timings-section">

          <app-receiving-hours [fromModule]="contentModule" (EditVal)="EditValFunc($event)"
            (update)="triggerFunc($event)" [deliveryTimings]="delHrs"></app-receiving-hours>
        </section>
      </form>
    </aside>

  </div>

</section>